import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTheme } from "styled-components";
import { useInterval } from "@cortexglobal/cortex-utilities";
import { Loading, PDFViewer } from "@cortexglobal/rla-components";

//@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import AssetPreviewOverlay from "./AssetPreviewOverlay";

const InDesignPdf = ({ asset, userAsset }) => {
    const validAsset = userAsset ? userAsset : asset;

    const [loaded, setLoaded] = useState(false);

    // console.log(validAsset)
    const [remainingTries, setRemainingTries] = useState(45);
    const [url, setUrl] = useState("");
    const theme = useTheme();

    const getPreviewFromApi = () => {
        axios
            .get(`/api/v1/assets/${validAsset.uuid}/pdf-preview`)
            .then(({ data }) => {
                if (data.data.url) {
                    setLoaded(true);
                    setUrl(data.data.url);
                    setRemainingTries(0);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    useEffect(() => {
        if (validAsset) {
            getPreviewFromApi();
        }
    }, [asset.updated_at]);

    useInterval(
        () => {
            if (
                (remainingTries && userAsset) ||
                (remainingTries && asset.userAsset)
            ) {
                getPreviewFromApi();
            }

            setRemainingTries(remainingTries - 1);
        },
        remainingTries < 1 ? null : 20000
    );

    return (
        <AssetPreviewOverlay>
            {!loaded ? (
                <Loading color={theme.asset.preview.color} />
            ) : (
                <PDFViewer filePath={`${url}`} style={{ maxWidth: "95%" }} />
            )}
        </AssetPreviewOverlay>
    );
};

export default InDesignPdf;
